module.exports = __webpack_public_path__ + "static/media/plus-white.fb5cb848.svg";